import React, { ReactChild } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import styles from './Dropdown.module.scss';

type Props = {
    text?: string;
    children?: ReactChild | ReactChild[];
    onClick?: () => void;
    url?: string;
    disabled?: boolean;
};

const DropdownItem: React.FC<Props> = ({ text, children, url, disabled, onClick }: Props) => {
    const { t } = useTranslation();

    if (disabled) {
        return <>
            <a style={{ textDecoration: 'none', cursor: 'not-allowed' }} className={styles.dropdownItem}
            data-tip={t('generic_types.forbidden_tooltip')}>
                {Boolean(text) && text}
                {children}
            </a>
            <ReactTooltip />
        </>
    }

    return (
        <>
            {onClick
                ? <a onClick={onClick} style={{ textDecoration: 'unset' }} className={styles.dropdownItem}>
                    {Boolean(text) && text}
                    {children}
                </a>
                : <Link to={url ?? ''} style={{ textDecoration: 'none' }} className={styles.dropdownItem}>
                    {Boolean(text) && text}
                    {children}
                </Link>}
        </>
    );
}

export default DropdownItem;